// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function strip1_viewportEnter(event, $w) {
	//Add your code for this event here: 
}

export function strip1_viewportLeave(event, $w) {
	//Add your code for this event here: 
}

export function strip1_mouseIn(event, $w) {
	//Add your code for this event here: 
}

export function strip1_mouseOut(event, $w) {
	//Add your code for this event here: 
}